import { forwardRef, memo } from 'react';

import useTranslation from '@Queries/useTranslation';
import SmartRender from '@Components/SmartRender';
import OrderedList from '../OrderedList';
import Attention from '../Attention/Attention';
import styles from './AcceptanceRules.module.css';

import type { HTMLAttributes } from 'react';

export interface AcceptanceRulesProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  acceptanceRules: string[];
  acceptanceProduct?: string;
  cnItem?: string;
}

const AcceptanceRules = forwardRef<HTMLDivElement, AcceptanceRulesProps>((props, ref) => {
  const { acceptanceRules, acceptanceProduct, cnItem, ...restProps } = props;

  const { t } = useTranslation();

  return (
    <div ref={ref} {...restProps}>
      <div className={styles.contentContainer}>
        <div>
          <div className={styles.heading}>{t('acceptance-rules.title')}</div>
          <div className={styles.rulesText}>{t('acceptance-rules.description')}</div>

          {acceptanceRules.length > 0 && (
            <div className={styles.wrapperList}>
              <SmartRender countries={['RUS', 'KAZ', 'UZB']}>
                <div className={styles.listTitle}>{t('acceptance-rules.list-title')}</div>
              </SmartRender>
              <OrderedList key={acceptanceRules[0]} list={acceptanceRules} cnItem={cnItem} />
            </div>
          )}
        </div>

        {acceptanceProduct && (
          <div>
            <Attention text={acceptanceProduct} />
          </div>
        )}
      </div>
    </div>
  );
});

AcceptanceRules.displayName = 'AcceptanceRules';

export default memo(AcceptanceRules);
